/**
 * Site configuration constants
 */
export const SITE_CONFIG = {
  name: 'Cloud9 Tasmania',
  tagline: 'Gardening, Cleaning & Taxidermy Services',
  description: 'Professional gardening, cleaning, and taxidermy services in Tasmania. Quality craftsmanship with a personal touch.',
  contact: {
    email: 'coco@cloud9tasmania.com',
    phone: '',
    location: 'Tasmania, Australia',
  },
  social: {
    facebook: '',
    instagram: '',
  },
} as const;

/**
 * Navigation links
 */
export const NAV_LINKS = [
  { href: '/', label: 'Home' },
  { href: '/services', label: 'Services' },
  { href: '/gallery', label: 'Gallery' },
  { href: '/about', label: 'About' },
  { href: '/contact', label: 'Contact' },
] as const;

/**
 * Service categories
 */
export const SERVICES = {
  gardening: {
    id: 'gardening',
    title: 'Gardening',
    description: 'Professional lawn care, hedge trimming, garden maintenance, and more.',
    href: '/services/gardening',
  },
  cleaning: {
    id: 'cleaning',
    title: 'Cleaning',
    description: 'Comprehensive cleaning services for homes and businesses.',
    href: '/services/cleaning',
  },
  taxidermy: {
    id: 'taxidermy',
    title: 'Taxidermy',
    description: 'Expert preservation and mounting of wildlife specimens.',
    href: '/services/taxidermy',
  },
} as const;

/**
 * Legal page links
 */
export const LEGAL_LINKS = [
  { href: '/legal/privacy', label: 'Privacy Policy' },
  { href: '/legal/terms', label: 'Terms of Service' },
  { href: '/legal/disclaimer', label: 'Disclaimer' },
  { href: '/legal/shipping', label: 'Shipping Policy' },
  { href: '/legal/accessibility', label: 'Accessibility' },
] as const;
